import { render } from "./RunningGiveaways.vue?vue&type=template&id=460f68d3&ts=true"
import script from "./RunningGiveaways.vue?vue&type=script&lang=ts"
export * from "./RunningGiveaways.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Documents\\Development\\juwie-giveaway\\juwie-giveaway-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__